
import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CertificadoDigitalRequest } from 'src/app/models/CertificadoDigital/CertificadoDigitalRequest';
import { OrigenCertificadoEnum } from 'src/app/models/CertificadoDigital/OrigenCertificadoEnum';
import { CERT_PRECIOS } from 'src/app/components/configuracion-dte/mantenedor-certificados/config-certificados';
import { TokenStorageService } from 'src/app/services/token-storage.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { FacturacionIndividualService } from 'src/app/services/facturacion-individual.service';
import { Emisor } from 'src/app/models/Emisor/Emisor';
import { VerificacionRutValidator,validarRut } from 'src/app/directives/verifica-rut.directive';
import { formatToRut } from 'src/app/directives/formatToRut.directive';
import Swal from 'sweetalert2';
import { ChangeDetectorRef } from '@angular/core';
import comunasData from 'src/app/models/CertificadoDigital/Comunas.json';
import { CertificadosDigitalesService } from 'src/app/services/certificados-digitales.service';
import { DatosFacturacionService } from 'src/app/services/datos-facturacion-service';
import { EmpresaFacturacion } from 'src/app/models/PlanesUsuario/DatosFacturacion';
import { SaldoSeleccion } from 'src/app/models/Saldo/SaldoSeleccion';
import { SaldoFavorCalculo } from 'src/app/components/pago/saldo-favor-bloque/saldo-favor-calculo';
import { PlaceholderEmailValidator } from 'src/app/directives/multi-email.directive';
export type CertMode = 'generar' | 'comprar' | 'renovar';

@Component({
  selector   : 'app-certificado-form',
  templateUrl: './certificado-form.component.html',
  styleUrls  : ['./certificado-form.component.scss']
})
export class CertificadoFormComponent implements OnInit {
  @Input() mode: CertMode = 'generar';
  @Input() defaults: Partial<CertificadoDigitalRequest> = {}; 
  @Input() rutEmisor!: number;   
  @Input() comunas: string[] = (comunasData as string[]).sort();

  @Output() submitted = new EventEmitter<{
    payload: CertificadoDigitalRequest;
    total?: number;
    stopLoading:  () => void;
    closeModal?: () => void;
  }>();

  public certificadoForm!: FormGroup;
  public empresaFacturacionCtrl = new FormControl(null);
  public buscandoDatos = false;
  public existe         = true;
  public loading: boolean = false;
  public empresasFacturacion: EmpresaFacturacion[] = [];
  public empresaSeleccionada: EmpresaFacturacion = null;
  public usarOtrosDatosFacturacion = false;
  public cargandoEmpresasFacturacion = false;
  
  public preciobase = 0;
  public precioGarantia = 0;
  public total = 0;
  public usarSaldoFavor = false;
  public saldoAplicadoEsperado = 0;
  public tablaPrecios: any[] = [];
  public periodos = [
    { value: 1, label: '1 Año' },
    { value: 2, label: '2 Años' },
    { value: 3, label: '3 Años' },
  ];

  private emisores: Emisor[];
  private sessionEmisor!: Emisor;
  private sessionEmisorId!: string;

  constructor(
    private fb     : FormBuilder,
    public  active : NgbActiveModal,
    private token  : TokenStorageService,
    private localStorageService     : LocalStorageService,
    private facturacionIndividualService   : FacturacionIndividualService,
     private certificadoService: CertificadosDigitalesService,
    private ref    : ChangeDetectorRef,
    private datosFacturacionService: DatosFacturacionService
  ) {
    this.sessionEmisorId = this.token.getCompany();
    this.emisores        = JSON.parse(this.localStorageService.getEmisores()) as Emisor[];
    this.sessionEmisor   = this.emisores.find(e => e.emisorId === this.sessionEmisorId)!;
  }
  ngOnInit(): void {
    this.buildForm();
    this.certificadoForm.patchValue(this.defaults);
    
    this.certificadoForm.get('duracion')!.valueChanges.subscribe(() => this.calcularPreciosCertificado());
    this.certificadoForm.get('garantia')!.valueChanges.subscribe(() => this.calcularPreciosCertificado());
    this.cargarTablaPrecios();
    this.calcularPreciosCertificado();

    this.empresaFacturacionCtrl.valueChanges.subscribe((empresa: EmpresaFacturacion) => {
      if (!empresa || this.usarOtrosDatosFacturacion) {
        return;
      }
      this.onEmpresaSeleccionada(empresa);
    });

    if (this.mode !== 'generar') {
      this.cargarEmpresasFacturacion();
    }
  }
  cargarTablaPrecios() {
    this.loading = true;
    this.certificadoService.getTarifasCertificado().subscribe({
      next: (data) => {
        this.tablaPrecios = this.periodos.map(periodo => {
          const precioCert = data.find(
            t => t.nombreProducto.toLowerCase() == "certificado digital" && t.anios === periodo.value
          );
          const precioGarantia = data.find(
            t => t.nombreProducto.toLowerCase().includes('garantía') && t.anios === periodo.value
          );
          return {
            duracion: periodo.value,
            precioCertificado: precioCert ? precioCert.precio : 0,
            precioGarantia: precioGarantia ? precioGarantia.precio : 0
          };
        });
        this.loading = false;
        this.ref.detectChanges();
      },
      error: () => {
        this.loading = false;
        this.tablaPrecios = [];
        this.ref.detectChanges();
      }
    });
  }


  calcularPreciosCertificado() {
      const duracion = this.certificadoForm.get('duracion')!.value;
      const garantia = this.certificadoForm.get('garantia')!.value;

      if (!duracion) {
        this.preciobase = 0;
        this.precioGarantia = 0;
        this.total = 0;
        return;
      }
      const fila = this.tablaPrecios.find(p => p.duracion == duracion);
      this.preciobase = fila ? fila.precioCertificado : 0;
      this.precioGarantia = garantia && fila ? fila.precioGarantia : 0;
      this.total = Math.round((this.preciobase + this.precioGarantia) * 1.19);

      this.ref.detectChanges();
  }


  get periodoSel() {
    return this.periodos.find(p => p.value === this.certificadoForm.get('duracion')!.value);
  }

  get netoPagarConSaldo(): number {
    return SaldoFavorCalculo.totalesConDescuentoNeto(
      this.preciobase + this.precioGarantia,
      this.usarSaldoFavor ? this.saldoAplicadoEsperado : 0
    ).neto;
  }

  get ivaPagarConSaldo(): number {
    return SaldoFavorCalculo.totalesConDescuentoNeto(
      this.preciobase + this.precioGarantia,
      this.usarSaldoFavor ? this.saldoAplicadoEsperado : 0
    ).iva;
  }

  get totalPagarConSaldo(): number {
    return SaldoFavorCalculo.totalesConDescuentoNeto(
      this.preciobase + this.precioGarantia,
      this.usarSaldoFavor ? this.saldoAplicadoEsperado : 0
    ).total;
  }

  actualizarSaldoFavor(seleccion: SaldoSeleccion): void {
    this.usarSaldoFavor = seleccion.usarSaldoFavor;
    this.saldoAplicadoEsperado = seleccion.saldoAplicadoEsperado;
  }
  async onSubmit(): Promise<void> {
    const rutFacturacion = this.certificadoForm.getRawValue().rut;
    if (!validarRut(rutFacturacion)) {
      this.certificadoForm.get('rut')?.markAsTouched();
      this.loading = false;
      await Swal.fire(
        'RUT de facturación inválido',
        'El RUT de los datos de facturación no es válido. Contacte al administrador para corregir los datos antes de continuar.',
        'error'
      );
      return;
    }

    if (this.certificadoForm.invalid) {
      this.certificadoForm.markAllAsTouched();

      if (this.certificadoForm.get('correo')?.hasError('placeholderEmail')) {
        await Swal.fire(
          'Correo requerido',
          'Debes ingresar un correo valido. No se permite usar sincorreo@sincorreo.cl para la compra o renovacion del certificado digital.',
          'warning'
        );
      }

      return;
    }
      const correoIngresado = this.certificadoForm.get('correo')!.value || '';

      if ((this.mode === 'comprar' || this.mode === 'renovar')) {
        const confirmarCorreo = await this.confirmarCorreoCompraRenovacion(correoIngresado, this.mode);
        if (!confirmarCorreo) {
          return;
        }
      }

      this.loading = true;
      this.ref.detectChanges();
    const formValues = this.certificadoForm.getRawValue();
    let duracion: number;
    if (typeof formValues.duracion === 'string') {
        const match = formValues.duracion.match(/\d+/);
        duracion = match ? parseInt(match[0], 10) : 1;
    } else {
        duracion = parseInt(formValues.duracion, 10) || 1;
    }

    const payload: CertificadoDigitalRequest = {
        ...formValues,
        telefonoContacto: formValues.telefonoContacto ? String(formValues.telefonoContacto) : null,
        duracion: duracion,
        rutEmisor: this.rutEmisor.toString(),
        activo: true,
        origen: OrigenCertificadoEnum.Simplefactura,
        subtotal: this.preciobase + this.precioGarantia,
        iva: Math.round((this.preciobase + this.precioGarantia) * 0.19),
        neto: this.preciobase + this.precioGarantia,
        total: this.total,
        idDatosFacturacion: this.empresaSeleccionada?.emisorDatosId,
        usarSaldoFavor: this.usarSaldoFavor,
        saldoAplicadoEsperado: this.usarSaldoFavor ? this.saldoAplicadoEsperado : 0
    };
    this.submitted.emit({
      payload,
      total: this.total,
      stopLoading: () => {
        this.loading = false;
        this.ref.detectChanges();
      },
      closeModal: () => {
        this.loading = false;
        this.ref.detectChanges();
        this.active.close();
      }
    });

  }

  private confirmarCorreoCompraRenovacion(correo: string, mode: CertMode): Promise<boolean> {
    const accion = mode === 'renovar' ? 'renovación' : 'compra';

    return Swal.fire({
      icon: 'warning',
      title: 'Confirmación de correo',
      html: `
        <div style="text-align: left">
          <p>Se enviará al correo <strong>${correo}</strong>:</p>
          <ul>
            <li>La factura correspondiente a la ${accion} del certificado</li>
            <li>Las instrucciones para generar el certificado digital</li>
          </ul>
          <p>¿Desea continuar con este correo?</p>
        </div>
      `,
      showCancelButton: true,
      confirmButtonText: 'Confirmar',
      cancelButtonText: 'Volver a editar',
      reverseButtons: true,
      confirmButtonColor: '#1b8bee',
      cancelButtonColor: '#6c757d'
    }).then((result) => result.isConfirmed);
  }

  buscaCliente(rutInput: string): void {
      if (!this.usarOtrosDatosFacturacion) {
        return;
      }

      const rut = rutInput.replace('.', '');
      if (!rut || rut.length <= 7) {
        Swal.fire('Error de formato', 'Ingrese un RUT válido para buscar', 'error');
        return;
      }

      if (!validarRut(rut)) {
        Swal.fire('Error de formato', 'Formato de RUT incorrecto', 'error');
        return;
      }



      const rutFmt = formatToRut(rut);
      this.certificadoForm.get('rut')!.setValue(rutFmt);

      this.buscandoDatos = true; this.ref.detectChanges();

       this.datosFacturacionService.ObtenerDatosFacturacion(null, rut).subscribe({
        next: (response) => {
          this.buscandoDatos = false;
          if (response?.length) {
            const cliente = response[0];
            this.existe = true;
            this.certificadoForm.patchValue({
              nombreEmpresa : cliente.razonSocial  || '',
              giroEmpresa   : cliente.giro    || '',
              direccion     : cliente.dirFact || '',
              comuna        : (cliente.comuna || this.sessionEmisor.comuna || '').toUpperCase(),
              correo        : cliente.correoFact,
              telefonoContacto: cliente.telefono ? String(cliente.telefono) : ''
            });
            Swal.fire('Cliente encontrado','Se completaron datos automáticamente','success');
          } else {
            this.noExisteCliente();
          }
          this.ref.detectChanges();
        },
        error: () => { this.noExisteCliente(); }
      });
  }
  private noExisteCliente() {
    this.buscandoDatos = false;
    this.existe        = false;
    Swal.fire('Cliente no encontrado','Complete los datos manualmente', 'info');
    this.certificadoForm.patchValue({
      nombreEmpresa : '',
      giroEmpresa   : '',
      direccion     : '',
      comuna        : '',
      correo        : '',
      telefonoContacto: ''
    });
    this.ref.detectChanges();
  }

  cargarEmpresasFacturacion() {
    this.empresaSeleccionada = null;
    this.empresasFacturacion = [];
    this.cargandoEmpresasFacturacion = true;
    this.empresaFacturacionCtrl.setValue(null, { emitEvent: false });
    
    this.datosFacturacionService.ObtenerDatosFacturacion(this.sessionEmisorId, null).subscribe({
      next: (empresas) => {
        this.cargandoEmpresasFacturacion = false;
        this.empresasFacturacion = empresas || [];
        if (this.empresasFacturacion.length > 0) {
          const empresaDefault = this.empresasFacturacion[0];
          this.empresaFacturacionCtrl.setValue(empresaDefault, { emitEvent: false });
          this.onEmpresaSeleccionada(empresaDefault);
        } else {
          this.usarOtrosDatosFacturacion = true;
          this.habilitarEdicionDatosFacturacion(true);
          this.limpiarDatosFacturacion();
        }
        this.ref.detectChanges();
      },
      error: (err) => {
        console.error('Error al cargar empresas de facturación:', err);
        this.cargandoEmpresasFacturacion = false;
        this.empresasFacturacion = [];
        this.usarOtrosDatosFacturacion = true;
        this.habilitarEdicionDatosFacturacion(true);
        this.ref.detectChanges();
      }
    });
  }

  onEmpresaSeleccionada(empresa: EmpresaFacturacion) {
    if (!empresa) {
      return;
    }
    
    this.empresaSeleccionada = empresa;
    this.usarOtrosDatosFacturacion = false;

    const rutEmpresa = empresa.rut && empresa.dv
      ? `${empresa.rut}-${empresa.dv}`
      : (empresa.rutString || '');

    this.certificadoForm.patchValue({
      rut             : rutEmpresa ? formatToRut(rutEmpresa) : '',
      nombreEmpresa   : empresa.razonSocial || '',
      giroEmpresa     : empresa.giro || '',
      direccion       : empresa.dirFact || '',
      comuna          : (empresa.comuna || '').toUpperCase(),
      correo          : empresa.correoFact || '',
      telefonoContacto: empresa.telefono ? String(empresa.telefono) : ''
    });

    this.habilitarEdicionDatosFacturacion(false);
    this.ref.detectChanges();
  }

  onToggleOtrosDatosFacturacion(checked: boolean) {
    this.usarOtrosDatosFacturacion = checked;

    if (checked) {
      this.habilitarEdicionDatosFacturacion(true);
      this.limpiarDatosFacturacion();
      this.existe = true;
    } else if (this.empresaSeleccionada) {
      this.onEmpresaSeleccionada(this.empresaSeleccionada);
    } else if (this.empresasFacturacion.length > 0) {
      const empresaDefault = this.empresasFacturacion[0];
      this.empresaFacturacionCtrl.setValue(empresaDefault, { emitEvent: false });
      this.onEmpresaSeleccionada(empresaDefault);
    } else {
      this.habilitarEdicionDatosFacturacion(true);
    }

    this.ref.detectChanges();
  }

  private habilitarEdicionDatosFacturacion(habilitar: boolean) {
    const controls = ['rut', 'nombreEmpresa', 'comuna', 'direccion', 'giroEmpresa', 'telefonoContacto'];

    controls.forEach((controlName) => {
      const control = this.certificadoForm.get(controlName);
      if (!control) {
        return;
      }
      if (habilitar) {
        control.enable({ emitEvent: false });
      } else {
        control.disable({ emitEvent: false });
      }
    });

    // Correo siempre editable
    this.certificadoForm.get('correo')?.enable({ emitEvent: false });
  }

  private limpiarDatosFacturacion() {
    this.certificadoForm.patchValue({
      rut             : '',
      nombreEmpresa   : '',
      giroEmpresa     : '',
      direccion       : '',
      comuna          : '',
      correo          : '',
      telefonoContacto: ''
    });
  }


  private buildForm(): void {
    this.certificadoForm = this.fb.group({
      rut             : [null, [Validators.required, VerificacionRutValidator, Validators.maxLength(10)]],
      correo          : [null, [Validators.required, Validators.email, PlaceholderEmailValidator]],
      duracion        : [null, Validators.required],
      nombreEmpresa   : [null, Validators.required],
      comuna          : [null, Validators.required],
      direccion       : [null, Validators.required],
      giroEmpresa     : [null, Validators.required],
      telefonoContacto: [null],
      garantia        : [false]
    });
  }
}
